/**
 * Videos Module
 * Handles video player interactions and controls
 */

import { $, $$, on, exists, addClass, removeClass, find, attr, each } from '../utils/dom.js';

export const initSideContentVideo = () => {
  on($$(".side-content-video__video svg"), "click", function () {
    const parent = this.parentElement;
    const video = find(parent, "video");
    if (video) {
      video.play();
      addClass(parent, "active");
    }
  });

  on($$(".side-content-video__video video"), "pause", function () {
    removeClass(this.parentElement, "active");
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".side-content-video__video")) {
      const video = $(".side-content-video__video video");
      if (video) {
        video.pause();
        removeClass(".side-content-video__video", "active");
      }
    }
  });
};

export const initMediaImageVideo = () => {
  if (exists(".media-image-video")) {
    on($$(".media-image-video__trigger"), "click", function (e) {
      e.preventDefault();
      addClass(".video-overlay", "active");
      addClass(".video-container", "active");
    });

    on($$(".video-overlay"), "click", function (e) {
      e.preventDefault();
      removeClass(".video-overlay", "active");
      removeClass(".video-container", "active");

      const iframe = $(".video-container iframe");
      if (iframe) {
        const iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }

      const video = $(".video-container video");
      if (video) {
        video.pause();
      }
    });
  }
};

export const initMediaVideoAutoplay = () => {
  if (!exists(".media-video-autoplay")) return;

  const containers = $$(".media-video-autoplay");

  each(containers, (container) => {
    const video = find(container, ".media-video-autoplay__video");
    const playBtn = find(container, ".media-video-autoplay__control--play");
    const muteBtn = find(container, ".media-video-autoplay__control--mute");
    const fullscreenBtn = find(container, ".media-video-autoplay__control--fullscreen");

    if (!video) return;

    // Play/Pause toggle
    if (playBtn) {
      on(playBtn, "click", function() {
        if (video.paused) {
          video.play();
          attr(this, "data-playing", "true");
          attr(this, "aria-label", "Pause video");
        } else {
          video.pause();
          attr(this, "data-playing", "false");
          attr(this, "aria-label", "Play video");
        }
      });

      // Update button state when video plays/pauses from other sources
      on(video, "play", () => {
        attr(playBtn, "data-playing", "true");
        attr(playBtn, "aria-label", "Pause video");
      });

      on(video, "pause", () => {
        attr(playBtn, "data-playing", "false");
        attr(playBtn, "aria-label", "Play video");
      });
    }

    // Mute/Unmute toggle
    if (muteBtn) {
      on(muteBtn, "click", function() {
        const isMuted = video.muted;
        video.muted = !isMuted;

        // Update button state
        attr(this, "data-muted", !isMuted ? "true" : "false");
        attr(this, "aria-label", !isMuted ? "Unmute video" : "Mute video");
      });
    }

    // Fullscreen toggle - use simulated fullscreen to maintain 16:9 ratio
    if (fullscreenBtn) {
      on(fullscreenBtn, "click", function() {
        const isCurrentlyFullscreen = container.classList.contains('is-fullscreen');

        if (isCurrentlyFullscreen) {
          // Exit simulated fullscreen
          removeClass(container, 'is-fullscreen');
          removeClass(document.body, 'video-fullscreen-active');
          attr(fullscreenBtn, "data-fullscreen", "false");
          attr(fullscreenBtn, "aria-label", "Enter fullscreen");
        } else {
          // Enter simulated fullscreen
          addClass(container, 'is-fullscreen');
          addClass(document.body, 'video-fullscreen-active');
          attr(fullscreenBtn, "data-fullscreen", "true");
          attr(fullscreenBtn, "aria-label", "Exit fullscreen");
        }
      });

      // Allow ESC key to exit fullscreen
      on(document, "keydown", function(e) {
        if (e.key === "Escape" && container.classList.contains('is-fullscreen')) {
          removeClass(container, 'is-fullscreen');
          removeClass(document.body, 'video-fullscreen-active');
          attr(fullscreenBtn, "data-fullscreen", "false");
          attr(fullscreenBtn, "aria-label", "Enter fullscreen");
        }
      });
    }
  });
};
